import { render, staticRenderFns } from "./CustomerAccComp.vue?vue&type=template&id=65c2f01e&scoped=true"
import script from "./CustomerAccComp.vue?vue&type=script&lang=js"
export * from "./CustomerAccComp.vue?vue&type=script&lang=js"
import style0 from "./CustomerAccComp.vue?vue&type=style&index=0&id=65c2f01e&prod&scoped=true&lang=css"
import style1 from "./CustomerAccComp.vue?vue&type=style&index=1&id=65c2f01e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c2f01e",
  null
  
)

export default component.exports